import React from 'react';
import SarasPopup from '../../container/popup/SarasPopup';

const FormImgPopup = (props) => {
    const { formObject, action, headerKey, rowKey } = props;

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const src = formObject.getValueFromKey(viewData, "dataList.src", "");

    const hidePopup = () => {
        setOpen(false);
    };

    const showPopup = () => {
        setOpen(true);
    }

    if (src && hide === "0") {
        return (
            <>
                <div ref={anchorRef} style={{display:'inline-block'}}>
                    <img alt="" src={src}  style={{ width: "25px" }} onClick={showPopup} />
                </div>
                <SarasPopup anchorRef={anchorRef} open={open} onClose={hidePopup}>
                    <img alt="" src={src} style={{ width: "150px" }}  />
                </SarasPopup>
            </>
        )
    }

    return (
        null
    )
}

export default FormImgPopup